export default __webpack_public_path__ + "static/1364-6faab6e02bae6268a295c0de452807da.gif";